export const formatSendPagination = ({ page = 1, limit = 10 }) => `${page}:${limit}`
